export function httpGet(url: string, withCredentials = false): Promise<string> {
	const request = new XMLHttpRequest();
	const promise = new Promise<string>((resolve, reject) => {
		request.onreadystatechange = () => {
			if (request.readyState === 4) {
				if (request.status === 200) {
					resolve(request.responseText);
				} else {
					reject(new Error(request.statusText));
				}
			}
		};
	});
	request.withCredentials = withCredentials;
	request.open("GET", url, true);
	request.send();
	return promise;
}
